import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { useEffect, useState } from "react";
import $ from "jquery"
import Swal from "sweetalert2";
import dayjs from "dayjs";
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.css'
import UsersService from "../../services/UsersService";
import { Button } from "react-bootstrap";
import StatutsService from "../../services/StatutsService";
import ShowButton from "../../components/showButtonComponent";
import EditButton from "../../components/editButtonComponent";
import { useSelector } from "react-redux";

export default function IndexUsers() {

    //##########################/// METHODES ##########################///
    const [users, setUsers] = useState({})
    const navigate = useNavigate();
    const token = useSelector(state => state.auth.token)

    //get liste users
    const fetchUsers = async () => {
        await UsersService.index(token).then((res) => {
            //console.log(res.data.liste_utilisateurs)
            setUsers(res.data.liste_utilisateurs)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });

    }

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.users_edit, { state: { id: param } })
    }

    //redirection sur la page d'aperçu sans afficher les id dans l'url
    const goToShow = (param) => {
        navigate(myroutes.users_show, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                UsersService.delete(param,token).then((response) => {
                    if (response.data.erreur) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.erreur
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchUsers()
                    }

                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                })
            }
        })
    }

    //Rendre actif ou inactif un user
    const updateStatut = async (id, statut, table) => {
        //let form = {id, statut, table}
        await StatutsService.changeStatut(id, statut, table,token).then(response => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur
                })
            } else {
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
                fetchUsers()
            }
        }).catch(error => {
            console.log(error)
        })
    }

    useEffect(() => {
        fetchUsers();
        $("#submenu-4").addClass("show")
    }, [])


    //##########################/// END METHODES ##########################///


    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0">Administration</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item active">Utilisateurs </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Liste des Utilisateurs <Link className="btn btn-primary btn-sm" to={myroutes.users_create} title="Ajouter" ><i className="fa fa-plus-circle"></i></Link> </h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-orders-table shadow-lg mb-5">
                        <div className="app-card-body mx-3 py-2">
                            <div className="table-responsive mt-4">
                                <table className="table table-borderless table-hover app-table-hover mb-0 data-table">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="cell text-white">N°</th>
                                            <th className="cell text-white">Nom et pénoms </th>
                                            <th className="cell text-white">Email</th>
                                            <th className="cell text-white">Adresse</th>
                                            <th className="cell text-white">Rôles</th>
                                            <th className="cell text-white">Statuts</th>
                                            <th className="cell text-white">Date modification</th>
                                            <th className="cell text-white">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider" style={{ textAlign: "left" }}>
                                        {Object.values(users).map((item, index) => (
                                            <tr key={index}>
                                                <td className="cell">{index + 1}</td>
                                                <td className="cell">{item.nom + " " + item.prenoms} </td>
                                                <td className="cell">{item.email} </td>
                                                <td className="cell"><span className="truncate">{item.adresse}</span></td>
                                                <td className="cell">{/*Object.values(item.roles).map((option) => option + ',')*/} {item.roles + ' '}</td>
                                                <td className="cell"><span className={(item.get_statut === "ACTIF") ? "badge bg-success" : "badge bg-danger"}>{item.get_statut}</span></td>
                                                <td className="cell"><span>{dayjs(item.updated_at).format("DD/MM/YYYY à H:m:s")} </span></td>
                                                <td className="cell">
                                                    <Button className={item.get_statut === "ACTIF" ? "btn btn-sm btn-success" : "btn btn-sm btn-dark"} onClick={() => updateStatut(item.id, item.get_statut === "ACTIF" ? "desactivation" : "activation", "users")} title="Changer le statut">
                                                        <i className={item.get_statut === "ACTIF" ? "fas fa-eye" : "fas fa-eye-slash"}></i></Button>&nbsp;&nbsp;
                                                    <EditButton action={() => goToEdit(item.id)}></EditButton>&nbsp;&nbsp;
                                                    <ShowButton action={() => goToShow(item.id)}></ShowButton>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-danger" onClick={() => onDelete(item.id)} title="Supprimer">
                                                        <i className="fas fa-trash"></i></Button>
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>{/*//table-responsive*/}

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                    {/*//End table-content*/}


                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}